import * as React from "react";
import { scrollbarCSS } from "--floponents-web/common/scrollbarCss";
import { Editable } from "slate-react";
import { EditableProps, RenderPlaceholderProps } from "slate-react/dist/components/editable";
import styled from "styled-components";
import { noWrapCss } from "--components/typography";


const StyledReactEditable = styled(Editable)`
${scrollbarCSS()};
margin: ${({ theme }) => theme.spacing(1, 1)};
max-height: min(200px,50vh);
`
const StyledPlaceholder = styled.div`
    ${noWrapCss};
    width: calc(100% - ${({ theme }) => theme.spacing(2)});
    position: absolute;
    pointer-events: none;
    color: ${p => p.theme.palette.text.disabled};
`

export const SlateReactEditable: React.FC<EditableProps & { customPlaceholder?: React.ReactNode }> = props => {
    const { customPlaceholder, ...rest } = props;
    return <StyledReactEditable {...rest} placeholder={customPlaceholder ? "..." : props.placeholder} renderPlaceholder={(props: RenderPlaceholderProps) => {
        const { style, ...attr } = props.attributes

        return <StyledPlaceholder {...attr} color="red">
            {customPlaceholder || props.children}
        </StyledPlaceholder>
    }}>
        {props.children}
    </StyledReactEditable>
}